module.exports = __webpack_public_path__ + "img/Wellnesskarta4.17f7fb4b.jpg";